module.exports = __webpack_public_path__ + "static/media/guide.b3a49c0b.svg";